// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1dCLT","addWidgetButton":"Header_addWidgetButton__3Fbfa","dashboardTabs":"Header_dashboardTabs__2EGEy","active":"Header_active__Gw7EU"};